import React, { useMemo } from 'react';

import { compact } from 'lodash';

import { useDisclosure, Button } from '@chakra-ui/react';

import useTranslations from '../../../hooks/useTranslations';

import { ReportFragment, UserSummaryFragment } from '../../../graphql/generated/definitions';

import ReportSignatureModal from './ReportSignatureModal';

export default function ReportSignature({ report }: { report: ReportFragment }) {
  const t = useTranslations();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const signatories: (UserSummaryFragment & {
    reviewRole: "collaborator" | "referent" | "supervisor";
  })[] = useMemo(
    () =>
      compact([
        { ...report.review.collaborator, reviewRole: "collaborator" },
        ...report.review.reviewSupervisors.map(({ user }) => ({
          ...user,
          reviewRole: "supervisor",
        })),
        ...report.reportReferents.map(({ referent }) => ({
          ...referent,
          reviewRole: "referent",
        })),
      ]) as (UserSummaryFragment & {
        reviewRole: "collaborator" | "referent" | "supervisor";
      })[],
    [report]
  );

  return (
    <>
      <Button
        size="sm"
        variant="outline"
        color="darkBrand"
        onClick={onOpen}
        id="report-signature"
      >
        {t("reports.shared.digitalSignature")}
      </Button>
      <ReportSignatureModal
        report={report}
        signatories={signatories}
        open={isOpen}
        onClose={onClose}
      />
    </>
  );
}